/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

// Redux Store
import { ControlTable } from "../Table";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import systemAlert from "../../utils/systemAlert";
import { viewLoading } from "../../utils/loading";
// import { getCompanyTokenInfo } from "../../apis/auth";
// api
import { createMasterPassword, getCompanyToken, updateMasterPassword } from "../../apis/companies/companies";
import { getStoreCompanies, setProfile } from "../../store/actions";
import { useHistory } from "react-router";
import { get, isArray, isEmpty } from "lodash";
import MangerCompany from "../Manager/ManagerCompay";
import Filters from "../Filters";
import useForm from "../../hooks/useForm";
import ToolTip from "../ToolTip/ToolTip";
import { comma } from "../../utils/number";
import { getCareCompanyList, setPuaseCompanyWithTaxCompany } from "../../apis/admin/companies";
import MembershipHistory from "../Membership/MembershipHistory";
import MembershipHistoryChange from "../Membership/MembershipHistoryChange";
import Button from "../Button";
import { textAreaClipboardCopy } from "../../utils/browser";
import { toast } from "../../utils/toast";
import { getParams } from "../../utils/params";
import { getMemberships } from "../../apis/membership";

// import Company from "./company";

const CareCompanies = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [fields, setFields] = useState([]);
  const [myCareCompany, setMyCareCompany] = useState({});
  const [myCompany, setMyCompany] = useState({});
  const [open, setOpen] = useState(false);
  const [membershipOpen, setMembershipOpen] = useState(false);
  const [companyIdx, setCompanyIdx] = useState(null);
  const [membershipChangeOpen, setMembershipChangeOpen] = useState(false);
  const [notice, setNotice] = useState([]);
  const [memberships, setMemberships] = useState([]);
  const [filters, setFilters] = useState([]);


  const { careCompanies, user, companies, employee, taxContactType } = useSelector(
    (store) => ({
      careCompanies: store.Data.careCompanies,
      user: store.Profile.user,
      employee: store.Profile.employee,
      companies: store.Data.companies,
      taxContactType: store.TaxPortal.taxContactType,
    }),
    shallowEqual
  );


  const submit = (form) => {
    if (isEmpty(myCompany)) return;
    const { companyIdx, type } = myCompany;
    form = {
      ...form,
      search: {
        ...form.search,
        type,
        membershipIdx: form?.search?.membershipIdx,
      },
      taxSearchType: taxContactType,
    };

    if (form?.search?.membershipIdx === "all") {
      delete form.search.membershipIdx;
    } else {
      form.search.membershipIdx = +form?.search?.membershipIdx;
    }

    setIsLoading(true);

    getCareCompanyList(companyIdx, getParams(form))
      .then(res => {
        const { list, count } = res?.data;
        setList(list);
        setTotal(count);
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if (!isEmpty(user) && !isEmpty(companies))
      setMyCompany(companies.find((com) => com.companyIdx === user.managerCompanyIdx));
  }, [user, companies]);

  useEffect(() => {
    if (!isEmpty(careCompanies)) {
      setNotice([careCompanies[0]]);
    }
  }, [user, careCompanies]);

  useEffect(() => {
    getMemberships().then(res => {
      setMemberships([{ label: "전체", value: "all" }, ...res.rows?.map(item => ({
        ...item, value: item.idx
      }))]);
    });
  }, []);

  useEffect(() => {
    setFilters([
      {
        title: "상호",
        key: "search.name",
        options: {
          placeholder: "검색어 입력",
        },
      },
      {
        title: "사업자번호",
        key: "search.comNum",
        options: {
          placeholder: "검색어 입력",
        },
      },
      {
        title: "대표이름",
        key: "search.ceoName",
        options: {
          placeholder: "검색어 입력",
        },
      },
      {
        title: "담당자명",
        key: "search.managerName",
        options: {
          placeholder: "검색어 입력",
        },
      },
      {
        title: "멤버쉽 등급",
        key: "search.membershipIdx",
        type: "select",
        options: { list: memberships }
      },
    ]);
  }, [memberships]);

  useEffect(() => {
    setSubmit(submit);
    submit(form);
  }, [myCompany, taxContactType]);

  useEffect(() => {
    setFields([
      { title: "상호", label: '-', key: "name", className: 'text-align-center' },
      { title: "사업자번호", label: '-', key: "comNum", transform: "comNum" },
      { title: "대표자명", label: '-', key: "ceoName" },
      { title: "직원수", label: "-", key: "employees", onValue: (data) => data ? comma(data.length) : '-' },
      {
        title: "담당직원", label: '-', key: "managers",
        onValue: (value, fields, form) => (
          <>
            {isArray(value) &&
              <>
                {value.length} 명
                <ToolTip
                  tooltiptext={value
                    .map((c) => `${c.name}(${c.userId}) / ${c.companyManagerPerson.level === 1 ? '관리자' : '담당자'}`)
                    .join("\n\n")}
                  position="top"
                ></ToolTip>
              </>
            }
          </>
        )
      },

      { title: "수임일", label: '-', key: "startTime", type: 'date' },
      { title: "수임종료일", label: '-', key: "endTime", type: 'date' },
      {
        title: "상태", label: '-', key: "state", onValue: (value) => {
          return value === 'joined' ? '접속가능' : '접속불가';
        }
      },
      {
        title: "멤버십", label: '-', key: "companyMembership.membership.label",
      },
      {
        title: <>
          마스터 패스워드<ToolTip tooltiptext={"아이디는 -를 제외한 사업자번호입니다.\n비밀번호를 클릭하면 복사됩니다."} />
        </>,
        key: 'masterPassword',
        onValue: (v, _f, d) => {
          return (
            <>
              {
                !isEmpty(v) ? (
                  <div className="mt-3 mb-3">
                    <span
                      className="cursor-pointer"
                      onClick={() => {
                        textAreaClipboardCopy(v, '비밀번호가 복사되었습니다.');
                      }}
                    >
                      {v}
                    </span>
                    <br />
                    <Button
                      className="mt-5"
                      size="x-sm"
                      color="gray-line"
                      onClick={() => {
                        systemAlert(`"${d.name}"의 마스터계정 비밀번호를 정말 변경하시겠습니까?`, {
                          buttons: [
                            {
                              color: 'text',
                              label: '취소'
                            },
                            {
                              label: '확인',
                              onClick: () => {
                                const companyIdx = d.companyIdx;
                                updateMasterPassword(companyIdx)
                                  .then(res => {
                                    toast.success('변경이 완료되었습니다.');
                                    reSubmit();
                                  });
                              }
                            }
                          ]
                        });

                      }}
                    >
                      변경하기
                    </Button>
                  </div>
                ) : (
                  <Button
                    size="x-sm"
                    color="line"
                    onClick={() => {
                      const companyIdx = d.companyIdx;
                      createMasterPassword(companyIdx)
                        .then(res => {
                          toast.success('발급이 완료되었습니다.');
                          reSubmit();
                        });
                    }}
                  >
                    발급하기
                  </Button>
                )
              }
            </>
          );
        }
      },

      {
        type: 'button',
        size: 'x-sm',
        color: 'gray-line',
        onValue: (_v, _f, d) => {

          return d?.isTaxCompanyPause ? "재개" : "일시중지";
        },
        onClick: ({ data }) => {
          if (myCompany && data && myCompany.companyIdx === data.companyIdx) {
            return systemAlert('메인 회사는 일시중지할 수 없습니다.');
          }


          systemAlert(`"${data.name}"회사를 ${data.isTaxCompanyPause ? "재개" : "일시중지"}하시겠습니까?`, {
            buttons: [{
              label: '확인',
              onClick: () => {
                // 일시중지 API 호출
                setPuaseCompanyWithTaxCompany(
                  myCompany.companyIdx,
                  data.companyIdx,
                  { isPause: !data.isTaxCompanyPause }
                ).then((res) => {
                  systemAlert(`${data.isTaxCompanyPause ? "재개" : "일시중지"}가 완료되었습니다.`);
                  reSubmit();
                }).catch((err) => {
                  systemAlert(get(err, 'response.data.message') || err.response);
                }).finally(() => {
                  viewLoading(false);
                });
              }
            }, {
              color: 'line',
              label: '취소',
            }]
          });

        }
      },
      {
        type: 'button',
        size: 'x-sm',
        color: 'line',
        label: '접속 하기',
        onClick: ({ data }) => {
          if (data.state !== 'joined') {
            return systemAlert('접속가능한 회사가 아닙니다.');
          }
          systemAlert(`"${data.name}"회사로 접속하시겠습니까?`, {
            buttons: [{
              label: '확인',
              onClick: () => {
                const companyIdx = data.companyIdx;

                viewLoading(true);
                getCompanyToken({ companyIdx, type: employee.type })
                  .then(() => {
                    dispatch(setProfile());
                    history.push("/dashboard");
                  })
                  .catch((err) => {
                    systemAlert(get(err, 'response.data.message') || err.response);
                  })
                  .finally(() => {
                    viewLoading(false);
                  });
              }
            }, {
              color: 'line',
              label: '취소',
            }]
          });
        }
      },
      {
        type: 'button',
        size: 'x-sm',
        color: 'line',
        label: '매니저 수정',
        onClick: ({ data }) => {
          if (myCompany && data && myCompany.companyIdx === data.companyIdx) {
            return systemAlert('메인 회사는 수정 할 수 없습니다.');
          }
          setMyCareCompany(data);
          setOpen(true);
        }
      },
      {
        type: 'button',
        size: 'x-sm',
        color: 'line',
        label: '멤버십 설정',
        onClick: ({ data }) => {
          if (myCompany && data && myCompany.companyIdx === data.companyIdx) {
            return systemAlert('메인 회사는 수정 할 수 없습니다.');
          }
          setCompanyIdx(data.companyIdx);
          setMembershipOpen(true);
        }
      },
    ]);
  }, [careCompanies, dispatch, history, myCompany]);

  useEffect(() => {
    dispatch(getStoreCompanies());
  }, [dispatch]);


  const {
    form,
    handleOnChange,
    filterSubmit,
    reSubmit,
    setSubmit,
    list, setList,
    isLoading, setIsLoading,
    selectedList, setSelectedList,
    total, setTotal,
    limit, setLimit,
    page, setPage,
  } = useForm({
    search: {
      membershipIdx: 'all',
    },
    page: 0,
    limit: 10,
  });



  const tableButtons = [{
    label: "멤버십 설정",
    disabled: isEmpty(selectedList),
    action: () => { setMembershipChangeOpen(true); }

  }];

  return (
    <>
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        isControl={true}
        isLoading={isLoading}
        fields={fields}
        list={list}
        selectedList={selectedList}
        setSelected={setSelectedList}
        buttons={tableButtons}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        notices={notice}
        setLimit={setLimit}
      />
      <MangerCompany
        open={open}
        setOpen={setOpen}
        list={[myCompany]}
        type={myCompany.type}
        myCareCompany={myCareCompany}
        submit={reSubmit}
      />

      <MembershipHistory
        open={membershipOpen}
        setOpen={setMembershipOpen}
        submit={reSubmit}
        companyIdx={companyIdx}
      />

      <MembershipHistoryChange
        open={membershipChangeOpen}
        setOpen={setMembershipChangeOpen}
        submit={reSubmit}
        selectedList={selectedList}
        setSelectedList={setSelectedList}
      />
    </>
  );
};

export default CareCompanies;